export const isEmailValid = (email: string) => {
  const trimmedEmail = email?.trim();
  return trimmedEmail && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail);
};
